import ForgotPasswordForm from '@components/auth/forgot-password-form';
import SeoMetaHead from '@components/common/seo-meta-head';
import Header from '@components/common/header/header';
import { settingService } from '@services/setting.service';
import dynamic from 'next/dynamic';
import { NextPageContext } from 'next/types';

type P = {
  loginPlaceholderImage: string;
}

function Forgot({ loginPlaceholderImage }: P) {
  return (
    <>
      <SeoMetaHead pageTitle="Forgot Password" />
      <Header hideAuthButtons />
      <ForgotPasswordForm />
    </>
  );
}

Forgot.authenticate = false;
Forgot.layout = 'public';

export const getServerSideProps = async (ctx: NextPageContext) => {
  const meta = await settingService.valueByKeys([
    'loginPlaceholderImage'
  ]);

  return {
    props: {
      loginPlaceholderImage: meta?.loginPlaceholderImage || ''
    }
  };
};

export default Forgot;
